<template>
    <div class="contact-box" v-if="contact">
        <div class="card-info contact-list-card mb-3" v-bind:class="{ selected: isSelected }">
            <div class="contact-list-card-check" v-bind:class="{ 'show-check': showCheckbox }">
                <label class="custom-checkbox mb-0">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        v-model="isSelected"
                        :tabindex="showCheckbox ? 0 : -1"
                        :aria-label="contactName"
                        @change="selectContact()">
                    <span class="custom-control-label"></span>
                </label>
            </div>
            <a href="#" class="contact-list-card-main" @click.prevent="getContact(contact.id)">
                <span class="contact-list-card-avatar">
                    <img :src="profilePicture" alt="" v-if="profilePicture !== null">
                    <model-short-name v-bind:model="contact" v-else></model-short-name>
                </span>
                <span class="contact-list-card-identity">
                    <span class="contact-list-card-name">{{ displayName }}</span>
                    <span class="contact-list-card-detail" v-if="showDetail">{{ displayDetail }}</span>
                </span>
            </a>
            <div class="contact-list-card-tags" v-if="tags.length > 0">
                <span class="contact-list-card-tag" v-for="tag in tags" v-bind:key="tag" :title="tag">{{ tag }}</span>
            </div>
            <div class="contact-list-card-channels">
                <icons-main v-if="hasFacebook" name="facebook"></icons-main>
                <icons-main v-if="hasPhone || !hasFacebook" name="mobile" v-b-tooltip.hover.bottom="formatPhoneNumber(contact.attributes['phone-number'])"></icons-main>
            </div>
        </div>
    </div>
</template>

<script>

// Internal components
import ModelShortName from '../../components/ModelShortName.vue';
import IconsMain from '../IconsMain.vue';

// Internal services js
import { EventBus }   from '../../../helpers/EventBus.js';

// Import external libraries
import { mapActions } from 'vuex';
import { formatPhoneNumber, formatPhoneLabel } from '@/libraries/PhoneNumber';

export default {
    props: ['contact'],

    components: {
        ModelShortName,
        IconsMain
    },

    data () {
        return {
            isSelected:   false,
            showCheckbox: false
        };
    },

    computed: {
        profilePicture () {
            if (
                this.contact.attributes['profile-picture'] !== '' &&
                this.contact.attributes['profile-picture'] !== null
            ) {
                return this.contact.attributes['profile-picture'];
            }

            return null;
        },

        contactName () {
            const name = this.contact.attributes.name || this.contact.attributes['facebook-name'] || '';

            return name || this.contactDetail;
        },

        displayName () {
            return formatPhoneLabel(this.contactName);
        },

        displayDetail () {
            return formatPhoneLabel(this.contactDetail);
        },

        contactDetail () {
            return this.contact.attributes['phone-number'] || this.contact.attributes.email || '';
        },

        showDetail () {
            return !!this.contactDetail && this.contactDetail !== this.contactName;
        },

        hasFacebook () {
            return !!this.contact.attributes['facebook-id'];
        },

        hasPhone () {
            return !!this.contact.attributes['phone-number'];
        },

        tags () {
            return this.contact.attributes.tags || [];
        }
    },

    mounted () {
        EventBus.$on('open-select', this.handleOpenSelect);
        EventBus.$on('select-all', this.handleSelectAll);
        EventBus.$on('unselect-all', this.handleUnselectAll);
    },

    beforeDestroy () {
        EventBus.$off('open-select', this.handleOpenSelect);
        EventBus.$off('select-all', this.handleSelectAll);
        EventBus.$off('unselect-all', this.handleUnselectAll);
    },

    methods: {
        formatPhoneNumber,

        ...mapActions('core/contacts', [
            'getSingle'
        ]),

        /**
         * Show or hide the checkboxes.
         *
         * @param {Boolean} show
         * @return {void}
         */
        handleOpenSelect (show) {
            this.showCheckbox = show;
        },

        /**
         * Select all contacts.
         *
         * @return {void}
         */
        handleSelectAll () {
            this.isSelected = true;
        },

        /**
         * Unselect all contacts.
         *
         * @return {void}
         */
        handleUnselectAll () {
            this.isSelected = false;
        },

        /**
         * Set the Id of a contact in a session
         *
         * @return    void
         */
        getContact (contactId) {
            this.getSingle({ id: contactId }).then(() => {
                this.$router.push({ name: `contact:${this.$i18n.locale}` });
            });
        },

        /**
         * Emit the selected contact.
         *
         * @return {void}
         */
        selectContact () {
            EventBus.$emit(
                'selected-contact',
                this.contact,
                this.isSelected
            );
        }
    }
};
</script>
